import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { default as translation } from '../_i18n';

@Injectable()
export class TranslatorService {
  private lang;
  private translation_table: any;

  private default_lang = (localStorage.getItem(environment.lang))?localStorage.getItem(environment.lang):'th';

  constructor() {
    this.setTranslation(translation);
    this.setLanguage(this.default_lang);
  }

  setTranslation(t: any) {
    this.translation_table = t;
  }

  setLanguage(l: string) {
    localStorage.setItem(environment.lang,l);
    this.lang = l;
  }

  getLanguage(): string {
    return this.lang;
  }

  translate(t: string): string {
    if (!this.translation_table.hasOwnProperty(this.lang)) {
      return t;
    }
    if (!this.translation_table[this.lang].hasOwnProperty(t)) {
      return t;
    }
    return this.translation_table[this.lang][t];
  }
}
